import { useEffect } from 'react';

import { StoredMessage } from '@/types/schema';
import {
  convertOpenAIMessageToStoredMessage,
  isOpenAIMessage,
  isStoredMessage,
} from '@/utils/messages';

import { messagesToPatchedManifest } from '../components/manifest/serialized/prompts/ManifestChatPromptTemplate';
import {
  convertManifestToMessages,
  extractTemplateFormatFromKwargs,
} from '../components/manifest/serialized/prompts/ManifestChatPromptTemplate.utils';
import PromptTemplateSection from './PromptTemplateSection';
import { useDeep, usePlaygroundStore } from './hooks/usePlaygroundStore';

export const PromptPanel = ({
  index,
  promptCollapseState,
  setPromptCollapseState,
}: {
  index: number;
  promptCollapseState: boolean;
  setPromptCollapseState: (index: number, isAllCollapsed?: boolean) => void;
}) => {
  const manifest = usePlaygroundStore(
    useDeep((state) => state.prompts[index].manifest)
  );
  const setManifest = usePlaygroundStore((state) => state.setManifest);

  const isChatStyle = manifest.kwargs.first.id.at(-1) !== 'PromptTemplate';

  useEffect(() => {
    if (isChatStyle) {
      const messages = manifest.kwargs.first.kwargs.messages;

      const msgs = messages?.every((message) => isOpenAIMessage(message))
        ? messages.map((m) => convertOpenAIMessageToStoredMessage(m))
        : messages;

      const messageAlreadyFormatted = msgs?.every((message) =>
        isStoredMessage(message)
      );

      // recalculate the manifest with the updated input variables
      // we need this when we load in a previously run prompt that was initially
      // created with mustache formatting
      const manifestWithUpdatedInputVars = messagesToPatchedManifest(
        manifest.kwargs.first,
        messageAlreadyFormatted
          ? (messages as StoredMessage[]) ?? []
          : convertManifestToMessages(messages ?? []),
        extractTemplateFormatFromKwargs(manifest.kwargs.first.kwargs)
      );
      setManifest(index, {
        ...manifest,
        kwargs: {
          ...manifest.kwargs,
          first: {
            ...manifestWithUpdatedInputVars,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PromptTemplateSection
      index={index}
      promptCollapseState={promptCollapseState}
      setPromptCollapseState={setPromptCollapseState}
    />
  );
};
